<template lang="pug">
v-container(fluid)   
    List
</template>
<script>
import List from './components/ListForm.vue'
export default {
    components:{
            List
    },
    data(){
        return{
        }
    },
    methods:{
    }
}
</script>